import { render } from "./Menu.vue?vue&type=template&id=44e305d4&ts=true"
import script from "./menu?vue&type=script&lang=ts"
export * from "./menu?vue&type=script&lang=ts"

import "./_assets/_menu.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__